import { render, staticRenderFns } from "./statisticsPage.vue?vue&type=template&id=5a71ff0c&scoped=true"
import script from "./statisticsPage.vue?vue&type=script&lang=js"
export * from "./statisticsPage.vue?vue&type=script&lang=js"
import style0 from "./statisticsPage.vue?vue&type=style&index=0&id=5a71ff0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a71ff0c",
  null
  
)

export default component.exports